// extracted by mini-css-extract-plugin
module.exports = {"headerContentWrapper":"Header_headerContentWrapper__CJQwD","title":"Header_title__Zf1s_","subtitle":"Header_subtitle__5XyxO","status":"Header_status__3Kkqj"};